import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/layout/header/header.component';
import { HeroComponent } from './components/layout/hero/hero.component';
import { EventSectionComponent } from './components/layout/event-section/event-section.component';
import { InfoSectionComponent } from './components/layout/info-section/info-section.component';
import { HostSectionComponent } from './components/layout/host-section/host-section.component';
import { VideoSectionComponent } from './components/layout/video-section/video-section.component';
import { FormSectionComponent } from './components/layout/form-section/form-section.component';
import { EventComponent } from './components/event/event.component';
import { HostComponent } from './components/host/host.component';
import { DefaultComponent } from './components/pages/default/default.component';
import { FeeBasedComponent } from './components/pages/fee-based/fee-based.component';
import { SeniorLivingComponent } from './components/pages/senior-living/senior-living.component';

import { FooterComponent } from './components/layout/footer/footer.component';
import { FullFormComponent } from './components/form/full-form/full-form.component';
import { ReservationConfirmationComponent } from './components/form/reservation-confirmation/reservation-confirmation.component';
import { DividerImageComponent } from './components/layout/divider-image/divider-image.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PageLoaderComponent } from './components/loader/page-loader.component';
import { LoaderInterceptor } from './interceptor/loader.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AddToCalendarComponent } from './components/add-to-calendar/add-to-calendar.component';
import { JobReservationFailComponent } from './components/layout/job-reservation-fail/job-reservation-fail.component';
import { FirmInfoComponent } from './components/layout/firm-info/firm-info.component';
import { SinclairProsserComponent } from './components/layout/sinclair-prosser/sinclair-prosser.component';
import { MultiEventComponent } from './components/form/multi-event/multi-event.component';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HeroComponent,
    EventSectionComponent,
    InfoSectionComponent,
    HostSectionComponent,
    VideoSectionComponent,
    FormSectionComponent,
    EventComponent,
    HostComponent,
    DefaultComponent,
    FeeBasedComponent,
    SeniorLivingComponent,
    FullFormComponent,
    DividerImageComponent,
    ReservationConfirmationComponent,
    PageLoaderComponent,
    ReservationConfirmationComponent,
    AddToCalendarComponent,
    JobReservationFailComponent,
    FirmInfoComponent,
    SinclairProsserComponent,
    MultiEventComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgxSpinnerModule
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },],
  bootstrap: [AppComponent]
})
export class AppModule { }
